import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { IOrder } from '../../../../../interfaces/order';
import { getOrders } from '../../../../../crud/orders.crud';
import { Location } from './useGetLocations';

export const useGetLastLocations = () => {
  const fm = useFormatMessage();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState<Location[]>([]);
  const getLocations = async ({
    userId,
    disableLoading,
  }: {
    userId: number;
    disableLoading?: boolean;
  }) => {
    !disableLoading && setLoading(true);
    getOrders({ page: 1, per_page: 30, userId })
      .then(res => {
        const uniqueLocations: Location[] = [];
        res.data.data.forEach((order: IOrder) => {
          if (order.start_location && order.start_location.lat && order.start_location.lng) {
            const locationExist = uniqueLocations.find(
              i => i.lat === order.start_location.lat && i.lng === order.start_location.lng
            );
            if (!locationExist) {
              uniqueLocations.push({ ...order.start_location, createdAt: order.created_at });
            }
          }
          if (order.end_location && order.end_location.lat && order.end_location.lng) {
            const locationExist = uniqueLocations.find(
              i => i.lat === order.end_location.lat && i.lng === order.end_location.lng
            );
            if (!locationExist) {
              uniqueLocations.push({ ...order.end_location, createdAt: order.created_at });
            }
          }
        });
        setLocations(uniqueLocations);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        !disableLoading && setLoading(false);
      });
  };

  return { getLocations, locations, loading };
};
